module.exports = __webpack_public_path__ + "img/pagenotfound-image1.c934c6d6.png";